<template>

  <div>


    <div class="order-create__row custom-row" v-if="!isLabel">
      <div class="order-create__col custom-col"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_ChangeCarrier'])"></div>
        <DefaultCheckbox
            v-bind:class="{'label-red' : isAdmin}"
            class="bold big-label"
            :label="$t('fbm_ChangeCarrier.localization_value.value')"
            :value="FBM.data.changeCarrier"
            :disabled="isAdmin"
            @input="FBM.data.changeCarrier = !FBM.data.changeCarrier"
        />
      </div>
    </div>

    <div class="order-create__row custom-row">
<!--      v-bind:class="{'loading-cost': $store.getters.getOrdersFBMLoading}"-->
      <div class="order-create__col custom-col">
        <div class="order-create__toggle-block toggle-block small-size">
          <div class="toggle-block__type">
            <div class="toggle-block__type-list">
              <div class="toggle-block__type-item"
                   v-for="(item, index) in shippingCompanyData"
                   :key="index"
              >
                <RadioLabelPicture
                        name="shippingPartner"
                        :label="item.name"
                        :value="FBM.data.shippingPartnerType.delivery_company_id === item.delivery_company_id"
                        @change="changeShippingPartnerType(item)"
                >
                  <template slot="ico">
                    <img v-if="item.logo_base64" height="12" :src="item.logo_base64" alt="ico">
                  </template>
                </RadioLabelPicture>
              </div>

              <div class="toggle-block__type-item"
                   v-if="!isMobileFunc() && !isAdmin && !isLabel"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate([
                  'fbm_ShippingCalculating'
                ])"></div>
                <span class="site-link"
                      @click="$emit('showShippingCalculatorPopup')"
                >
                  {{$t('fbm_ShippingCalculating.localization_value.value')}}
                </span>
              </div>
            </div>

            <div v-if="FBM.data.Order.data.fileLabel"
                 class="mb-3"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['fbm_LabelAdmin'])"></div>
              <router-link :to="$store.getters.GET_PATHS.getPdfFile + '/' + FBM.data.Order.data.fileLabel.uuid" :target="'_blank'">
                <MainButton
                    style="min-width: 149px;"
                    class="order-create__footer-btn-i secondary"
                    :value="$t('fbm_LabelAdmin.localization_value.value')"
                />
              </router-link>
            </div>

            <div v-if="getLabelBarcode"
                 class="mb-3"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['fbm_LabelBarcodeAdmin'])"></div>
              <router-link :to="$store.getters.GET_PATHS.getPdfFile + '/' + getLabelBarcode.uuid" :target="'_blank'">
                <MainButton
                    style="min-width: 149px;"
                    class="order-create__footer-btn-i secondary"
                    :value="$t('fbm_LabelBarcodeAdmin.localization_value.value')"
                />
              </router-link>
            </div>

            <template v-if="_.has(FBM.data.shippingPartner, 'delivery_driver_service_name') &&
            FBM.data.shippingPartner.delivery_driver_service_name === 'easyPost'">
              <div v-if="FBM.data.trackingNumberRefund === 1"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['fbm_labelRefunded', 'fbm_labelRefund'])"></div>
                <TooltipTextHelperPlugin >
                  <template slot="text">
                    <StatusIcoBtn :type="'active'" class="ml-2"/>
                  </template>
                  <template slot="paragraph">
                    {{$t('fbm_labelRefunded.localization_value.value')}}
                  </template>
                </TooltipTextHelperPlugin>
              </div>

              <div v-if="FBM.data.Order.data.oldStatus.value === FBM_ALL_STATUSES.FBM_COMPLETED_STATUS.value && FBM.data.trackingNumberRefund === 0"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['fbm_labelRefunded', 'fbm_labelRefund'])"></div>
                <MainButton
                    style="min-width: 149px;"
                    class="order-create__footer-btn-i secondary"
                    :value="$t('fbm_labelRefund.localization_value.value')"
                    @click.native="returnLabel"
                />
              </div>
            </template>

<!--            <div v-if="FBM.data.fileGift"-->
<!--                 class="mt-3"-->
<!--                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">-->
<!--              <div class="admin-edit" @click="editTranslate(['fbm_GiftMessage'])"></div>-->
<!--              <router-link :to="$store.getters.GET_PATHS.getPdfFile + '/' + FBM.data.fileGift.uuid" :target="'_blank'">-->
<!--                <MainButton-->
<!--                    class="order-create__footer-btn-i secondary"-->
<!--                    :value="$t('fbm_GiftMessage.localization_value.value')"-->
<!--                />-->
<!--              </router-link>-->
<!--            </div>-->
          </div>

          <template v-if="!$store.getters.getOrdersFBMCompanyLoading && !(FBM.data.useEasyPost && _.has(getShippingPartner, 'shipping_methods') && getShippingPartner['shipping_methods'].length === 1) ||
            (this.isCurrentUserRoleUser && FBM.data.useEasyPost && !this.isLabel)">
            <div class="toggle-block__details w-100" v-if="shippingPartner = FBM.data.shippingPartner">
              <div class="toggle-block__details-head flex-column">
                <div class="toggle-block__details-title">
                  <img v-if="FBM.data.shippingPartnerType.logo_base64" height="28" style="max-width: 100px" :src="FBM.data.shippingPartnerType.logo_base64" alt="ico">
                </div>
              </div>
              <div class="toggle-block__details-body"
              >
                <div class="custom-row">
                  <div class="custom-col flex-column-reverse mb-2"
                       v-if="getShippingPartner"
                  >
                    <template
                        v-for="(itemShippingPartner, index) in getShippingPartner['shipping_methods']">
                      <RadioDefault
                          v-if="checkShippingPartnerRequireSignature(itemShippingPartner)"
                          class="mb-2 w-auto"
                          name="fedexRadioList"
                          :key="index + 'shippingPartner'"
                          :label="itemShippingPartner.name"
                          :value="FBM.data.shippingPartner && FBM.data.shippingPartner.id === itemShippingPartner.id"
                          :cardFlex="true"
                          @mouseup.native="changeShippingPartner(itemShippingPartner)"
                      >

                        <template slot="card">
                          <div v-if="APC_CAMBRIDGE.deliveryCompanyId === FBM.data.shippingPartnerType.delivery_company_id"
                               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                            <div class="admin-edit" @click="editTranslate(['fbm_companyMailPack','fbm_companyCourierPack', 'fbm_companyParcel'])"></div>
                            <TooltipTextHelperPlugin>
                              <template slot="text"><TooltipBtn class="tooltip-target"/></template>
                              <template slot="paragraph">
                                <span v-if="itemShippingPartner.id === 22">{{$t('fbm_companyMailPack.localization_value.value')}}</span>
                                <span v-if="itemShippingPartner.id === 23">{{$t('fbm_companyCourierPack.localization_value.value')}}</span>
                                <span v-if="itemShippingPartner.id === 24">{{$t('fbm_companyParcel.localization_value.value')}}</span>
                              </template>
                            </TooltipTextHelperPlugin>
                          </div>
                        </template>
                      </RadioDefault>
                    </template>
                  </div>
<!--                  checkSelectedUSACountry &&-->
                  <div class="custom-col mb-2"
                       v-if="FBM.data.shippingPartnerType.signature_price && FBM.data.shippingPartner.can_requaire_signature"
                       v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                    <div class="admin-edit" @click="editTranslate([
                      'fbm_TheSignFromRecepient',
                      'fbm_ServiceFee',
                      'fbm_ViewPrices'
                    ])"></div>
                    <DefaultCheckbox
                            class="bold"
                            :label="$t('fbm_TheSignFromRecepient.localization_value.value')"
                            :value="FBM.data.signFromRecipient"
                            @input="changeSignFromRecipient"
                    />
<!--                            v-model="FBM.data.signFromRecipient"-->

                    <div class="amount-row light pl-4 mt-2" v-if="Number(FBM.data.shippingPartnerType.signature_price) > 0">
                      <template v-if="FBM.data.shippingPartnerType.delivery_service_code === FBM_SHIPPING_TYPES.FBM_SHIPPING_FEDEX.delivery_service_code">
                        {{$t('fbm_ServiceFeeFedex.localization_value.value')}}
                      </template>
                      <template v-else-if="FBM.data.shippingPartnerType.delivery_service_code === FBM_SHIPPING_TYPES.FBM_SHIPPING_USPS.delivery_service_code">
                        {{$t('fbm_ServiceFeeUsps.localization_value.value')}}
                      </template>
                      <template v-else>
                        {{$t('fbm_ServiceFee.localization_value.value')}}
                      </template>

<!--                      <span class="ml-1">-->
<!--                        ${{FBM.data.shippingPartnerType.signature_price}}-->
<!--                      </span>-->
                    </div>
                  </div>

                  <div class="custom-col mb-2"
                       v-if="FBM.data.shippingPartner.possible_saturday_delivery"
                       v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                    <div class="admin-edit" @click="editTranslate(['fbm_PossibleSaturdayDelivery',])"></div>
                    <DefaultCheckbox
                            class="bold"
                            :label="$t('fbm_PossibleSaturdayDelivery.localization_value.value')"
                            v-model="FBM.data.possibleSaturdayDelivery"
                            @changeCheckbox="calculatePriceUser"
                    />
                  </div>

                  <div class="custom-col mb-0"
                       v-if="isAdminManage"
                  >
                    <div style="justify-content: flex-start;" class="toggle-block__details-bottom"
                         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                      <div class="admin-edit" @click="editTranslate(['fbm_CalculatePrice', 'fbm_reCreateLabel'])"></div>
                      <MainButton
                              class="wfc mr-3 mb-2"
                              :value="$t('fbm_CalculatePrice.localization_value.value')"
                              @click.native="calculatePriceAdmin"
                      />
                      <MainButton
                          v-if="isAdminManage && FBM.data.Order.data.fileLabel"
                          class="wfc mb-2"
                          :value="$t('fbm_reCreateLabel.localization_value.value')"
                          @click.native="$emit('reCreateLabel')"
                          v-bind:class="{'disabled-btn' : $store.getters.getOrdersFBMBtn}"
                      />
                    </div>
                  </div>

<!--                  <div class="custom-col mt-3 mb-0"-->
<!--                       v-if="isAdminManage && FBM.data.Order.data.fileLabel"-->
<!--                  >-->
<!--                    <div class="toggle-block__details-bottom"-->
<!--                         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">-->
<!--                      <div class="admin-edit" @click="editTranslate(['fbm_reCreateLabel',])"></div>-->
<!--                      <MainButton-->
<!--                              class="wfc"-->
<!--                              :value="$t('fbm_reCreateLabel.localization_value.value')"-->
<!--                              @click.native="$emit('reCreateLabel')"-->
<!--                      />-->
<!--                    </div>-->
<!--                  </div>-->

                </div>
              </div>
            </div>
          </template>
          <template v-else-if="$store.getters.getOrdersFBMCompanyLoading">
            <div class="toggle-block__details w-100 ml-5">
              <div class="d-flex justify-content-center align-items-center">
                <DotsShadowPreloader/>
              </div>
            </div>
          </template>

          <template v-if="!$store.getters.getOrdersFBMLoading && !$store.getters.getOrdersFBABtn">
            <div class="toggle-block__details w-100 ml-5" v-if="FBM.data.useEasyPost && (this.isLabel || this.isAdmin)">

              <div class="toggle-block__details-head flex-column">
                <div class="toggle-block__details-title">
                  <img v-if="FBM.data.shippingPartnerType.logo_base64" height="22" :src="FBM.data.shippingPartnerType.logo_base64" alt="ico">
                </div>
              </div>
              <div class="toggle-block__details-body"
              >
                <div class="custom-row" v-if="FBM.data.shippingAPIPrices && Object.keys(FBM.data.shippingAPIPrices).length">
                  <div class="custom-col flex-column-reverse mb-2">
                    <RadioDefault
                            class="mb-2"
                            name="fedexRadioListRate"
                            v-for="(itemShippingAPIPrices, index) in FBM.data.shippingAPIPrices"
                            :key="index + 'shippingPrice'"
                            :label="shippingPriceRadioLabel(itemShippingAPIPrices)"
                            :value="FBM.data.shippingAPIPrice && FBM.data.shippingAPIPrice.driver_delivery_method_id === itemShippingAPIPrices.driver_delivery_method_id"
                            @click.native="changeShippingAPIPrices(itemShippingAPIPrices)"
                    />
                  </div>

                  <template v-if="_.has(FBM.data.shippingPartnerType, 'signature_price') && getShippingPartner['shipping_methods'].length === 1">
<!--                    checkSelectedUSACountry &&-->
                    <div class="custom-col mb-2"
                         v-if=" FBM.data.shippingPartnerType.signature_price && FBM.data.shippingPartner.can_requaire_signature"
                         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                      <div class="admin-edit" @click="editTranslate([
                        'fbm_TheSignFromRecepient',
                        'fbm_ServiceFee',
                        'fbm_ViewPrices'
                        ])"></div>
                      <DefaultCheckbox
                              class="bold"
                              :label="$t('fbm_TheSignFromRecepient.localization_value.value')"
                              :value="FBM.data.signFromRecipient"
                              @input="changeSignFromRecipient"
                      />
                      <div class="amount-row light pl-4 mt-2" v-if="Number(FBM.data.shippingPartnerType.signature_price) > 0">
                        <template v-if="FBM.data.shippingPartnerType.delivery_service_code === FBM_SHIPPING_TYPES.FBM_SHIPPING_FEDEX.delivery_service_code">
                          {{$t('fbm_ServiceFeeFedex.localization_value.value')}}
                        </template>
                        <template v-else-if="FBM.data.shippingPartnerType.delivery_service_code === FBM_SHIPPING_TYPES.FBM_SHIPPING_USPS.delivery_service_code">
                          {{$t('fbm_ServiceFeeUsps.localization_value.value')}}
                        </template>
                        <template v-else>
                          {{$t('fbm_ServiceFee.localization_value.value')}}
                        </template>

<!--                        <span class="ml-1">-->
<!--                          ${{FBM.data.shippingPartnerType.signature_price}}-->
<!--                        </span>-->
                      </div>
                    </div>

                    <div class="custom-col mb-2"
                         v-if="FBM.data.shippingPartner.possible_saturday_delivery"
                         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                      <div class="admin-edit" @click="editTranslate(['fbm_PossibleSaturdayDelivery',])"></div>
                      <DefaultCheckbox
                              class="bold"
                              :label="$t('fbm_PossibleSaturdayDelivery.localization_value.value')"
                              v-model="FBM.data.possibleSaturdayDelivery"
                              @changeCheckbox="calculatePriceUser"
                      />
                    </div>

                    <div class="custom-col mb-0"
                         v-if="isAdminManage"
                    >
                      <div style="justify-content: flex-start;" class="toggle-block__details-bottom"
                           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                        <div class="admin-edit" @click="editTranslate(['fbm_CalculatePrice', 'fbm_reCreateLabel'])"></div>
                        <MainButton
                            class="wfc mr-3"
                            :value="$t('fbm_CalculatePrice.localization_value.value')"
                            @click.native="calculatePriceAdmin"
                        />
                        <MainButton
                            v-if="isAdminManage && FBM.data.Order.data.fileLabel"
                            class="wfc"
                            :value="$t('fbm_reCreateLabel.localization_value.value')"
                            @click.native="$emit('reCreateLabel')"
                            v-bind:class="{'disabled-btn' : $store.getters.getOrdersFBMBtn}"
                        />
                      </div>
                    </div>

                  </template>

<!--                  <div class="custom-col mb-0"-->
<!--                       v-if="isAdminManage"-->
<!--                  >-->
<!--                    <div class="toggle-block__details-bottom"-->
<!--                         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">-->
<!--                      <div class="admin-edit" @click="editTranslate(['fbm_CalculatePrice',])"></div>-->
<!--                      <MainButton-->
<!--                              class="wfc"-->
<!--                              :value="$t('fbm_CalculatePrice.localization_value.value')"-->
<!--                              @click.native="calculatePriceAdmin"-->
<!--                      />-->
<!--                    </div>-->
<!--                  </div>-->

                </div>

                <div class="custom-row" v-if="FBM.data.shippingAPIPrices && Object.keys(FBM.data.shippingAPIPrices).length === 0">
                  <div class="custom-col">
                    <div v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                      <div class="admin-edit" @click="editTranslate(['fbm_NoPricesAvailable'])"></div>
                      {{$t('fbm_NoPricesAvailable.localization_value.value')}}
                    </div>
                    <div v-if="isAdminManage">
                      <div class="toggle-block__details-bottom"
                           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                        <div class="admin-edit" @click="editTranslate(['fbm_CalculatePrice',])"></div>
                        <MainButton
                            class="wfc"
                            :value="$t('fbm_CalculatePrice.localization_value.value')"
                            @click.native="calculatePriceAdmin"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-else-if="FBM.data.useEasyPost">
            <div class="toggle-block__details w-100 ml-5">
              <div class="d-flex justify-content-center align-items-center">
                <DotsShadowPreloader/>
              </div>
            </div>
          </template>


        </div>
      </div>
    </div>

    <video style="width: 0 !important; height: 0 !important; padding: 0 !important; margin: 0 !important;"></video>
  </div>

</template>

<script>
  import RadioLabelPicture from "../../../../../../UI/radiobuttons/RadioLabelPicture/RadioLabelPicture";
  import RadioDefault from "../../../../../../UI/radiobuttons/RadioDefault/RadioDefault";
  import DefaultCheckbox from "../../../../../../UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
  import {mixinDetictingMobile} from "../../../../../../../mixins/mobileFunctions";
  import {FBMMixins} from "../../../../../../../mixins/FBMMixins/FBMMixins";
  import {APC_CAMBRIDGE, FBM_ALL_STATUSES, FBM_SHIPPING_TYPES} from "../../../../../../../staticData/staticVariables";
  import MainButton from "@/components/UI/buttons/MainButton/MainButton";
  import DotsShadowPreloader
    from "../../../../../../coreComponents/preloaders/DotsShadowPreloader/DotsShadowPreloader";
  import TooltipBtn from "@/components/UI/tooltips/TooltipBtn/TooltipBtn";
  import StatusIcoBtn from "@/components/UI/status/StatusIcoBtn/StatusIcoBtn";
  import TooltipTextHelperPlugin from "@/components/coreComponents/TooltipTextHelperPlugin/TooltipTextHelperPlugin";

  export default {
    name: "Shipping",

    components: {
      TooltipTextHelperPlugin,
      StatusIcoBtn,
      TooltipBtn,
      DotsShadowPreloader,
      MainButton,
      DefaultCheckbox,
      RadioDefault,
      RadioLabelPicture
    },

    mixins: [mixinDetictingMobile, FBMMixins],

    props: {
      FBM: Object,
      shippingCompanyData: Array,
      reloadKey: Number,
      isAdminManage: {
        type: Boolean,
        default: false
      }
    },

    watch: {
      // getShippingPartner(newVal) {
      //   if(newVal && this.isLabel){
      //     this.getShippingPrices(this.isAdminManage)
      //   }
      // },

      reloadKey(newVal){
        if(newVal && this.isLabel){
          this.getShippingPrices(this.isAdminManage)
        }
      }
    },

    computed: {
      getShippingPartner(){
        let partner = this._.find(this.shippingCompanyData, {delivery_company_id: this.FBM.data.shippingPartnerType.delivery_company_id})

        if(!partner) {
          partner = this._.first(this.shippingCompanyData)
          console.log(111);
          this.initShippingCompanies()
        }

        return partner
      },

    },


    data() {
      return {
        FBM_SHIPPING_TYPES: FBM_SHIPPING_TYPES,

        APC_CAMBRIDGE: APC_CAMBRIDGE,
        FBM_ALL_STATUSES: FBM_ALL_STATUSES,
      }
    },

    mounted() {
      /**
       * if label || has shipping API Prices (for admin manage)
       */
      if(this.isLabel || (this.FBM.data.shippingAPIPrices && Object.keys(this.FBM.data.shippingAPIPrices).length)){
        this.FBM.data.useEasyPost = true
      }

      console.log(222);
      this.initShippingCompanies(this.isAdminManage)

    },

    methods: {

      checkShippingPartnerRequireSignature(itemShippingPartner) {
        if(!this._.has(itemShippingPartner, 'requaire_signature')) return true

        if(this.FBM.data.signFromRecipient && itemShippingPartner.requaire_signature) return true

        if(!this.FBM.data.signFromRecipient && !itemShippingPartner.requaire_signature) return true

        return false
      },

      changeSignFromRecipient() {
        this.FBM.data.signFromRecipient = !this.FBM.data.signFromRecipient

        if(this.FBM.data.useEasyPost && (this.isLabel || this.isAdminManage)){
          this.getShippingPrices(this.isAdminManage)
          return
        }

        if(Number(this.FBM.data.shippingPartnerType.signature_price) === 0) {
          if(!this.FBM.data.signFromRecipient && this.FBM.data.shippingPartner?.requaire_signature) {
            // this.changeShippingPartner(this._.find(this.getShippingPartner['shipping_methods'], {requaire_signature: false}))
            switch (this.FBM.data.shippingPartner.id) {
              case 45:
                this.changeShippingPartner(this._.find(this.getShippingPartner['shipping_methods'], {id: 41}))
                break
              case 46:
                this.changeShippingPartner(this._.find(this.getShippingPartner['shipping_methods'], {id: 42}))
                break
              case 47:
                this.changeShippingPartner(this._.find(this.getShippingPartner['shipping_methods'], {id: 43}))
                break
              case 48:
                this.changeShippingPartner(this._.find(this.getShippingPartner['shipping_methods'], {id: 44}))
                break
            }
          }
          if(this.FBM.data.signFromRecipient && !this.FBM.data.shippingPartner?.requaire_signature) {
            // this.changeShippingPartner(this._.find(this.getShippingPartner['shipping_methods'], {requaire_signature: true}))
            switch (this.FBM.data.shippingPartner.id) {
              case 41:
                this.changeShippingPartner(this._.find(this.getShippingPartner['shipping_methods'], {id: 45}))
                break
              case 42:
                this.changeShippingPartner(this._.find(this.getShippingPartner['shipping_methods'], {id: 46}))
                break
              case 43:
                this.changeShippingPartner(this._.find(this.getShippingPartner['shipping_methods'], {id: 47}))
                break
              case 44:
                this.changeShippingPartner(this._.find(this.getShippingPartner['shipping_methods'], {id: 48}))
                break
            }
          }
          // this.checkShippingCompany().then(() => {
          //   this.initShippingCompanies(this.isAdminManage)
          //   if(this.FBM.data.useEasyPost === true) {
          //     this.getShippingPrices(this.isAdminManage)
          //   }
          // })
        }
      },

      calculatePriceAdmin() {
        this.FBM.data.useEasyPost = true
        this.getShippingPrices(this.isAdminManage)

        // Take a photo by web camera
        this.takePhoto()
      },

      calculatePriceUser() {
        this.getShippingPrices(this.isAdminManage)
      },

      shippingPriceRadioLabel(itemShippingAPIPrices) {
        let label = itemShippingAPIPrices.name + ' $' + itemShippingAPIPrices.shipmentCost + ' ' +
          `${itemShippingAPIPrices.warning_message ? itemShippingAPIPrices.warning_message : ''}`
        if(parseFloat(itemShippingAPIPrices.insuranceCost) > 0){
          label += ' insurance $' + itemShippingAPIPrices.insuranceCost
        }
        return label
      },

      changeShippingPartnerType(val){
        this.FBM.setShippingPartnerType(val)
        this.changeShippingAPIPrices({})
        this.changeShippingPartner(this._.first(val['shipping_methods']))

        // if(val['shipping_methods'].length === 1){
        // this.FBM.setShippingPartner(this._.first(val['shipping_methods']))
        // }
      },

      changeShippingPartner(val){
        this.FBM.setShippingPartner(val)

        if(this.FBM.data.useEasyPost && (this.isLabel || this.isAdmin)){
          this.getShippingPrices(this.isAdminManage)
        }
      },

      changeShippingAPIPrices(val){
        this.FBM.setShippingAPIPrice(val)
      },

      addressTypeeChange(){
        console.log('addressTypeeChange');
      },

      returnLabel() {
        let text = {
          title: 'common_AreYouSure',
          txt: '',
          yes: 'common_confirm',
          no: 'common_confirmNo'
        }

        let confirm = () => {

          let data = {
            "order_fbm_id" : this.FBM.data.Order.data.id
          }

          this.$store.dispatch('FBMLabelRefund', data).then((response) => {
            switch (this.getResponseStatus(response)) {
                /**
                 * Success
                 */
              case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
                this.openNotify('success', 'common_notificationRecordChanged')
                this.$emit('reload')
                break
              }
                /**
                 * Validation Error
                 */
              case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
                let errors = response.response.data.errors;
                this.notifyErrorHelper(errors)
                break
              }
                /**
                 * Undefined Error
                 */
              default: {
                this.openNotify('error', 'common_notificationUndefinedError')
              }
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

    }

  }
</script>

<style scoped>
.loading-cost {
  pointer-events: none;
}

.big-label >>> .default-checkbox__label {
  font-size: 16px;
  line-height: 15px;
}

.label-red >>> .default-checkbox__label {
  color: #ff0c0c;
}
</style>
